  var compliancePlayer;
  var assistPlayer;
  var proactivePlayer;

(function($) {

  // Declare global variables to remove warnings
  /* global server_variables */
  /* global URI */
  /* global window */
  /* global ImageZoom */
  
  // Get variables passed from enqueue-scripts.php
  var siteUrl = server_variables.siteUrl;
  var stylesheetUrl = server_variables.stylesheetUrl;
  var uploadsUrl = server_variables.uploadsUrl;

  $(document).ready(function() {

    // Homepage Slideshow
 
    // Variables for slideshow
    var header = [  "Innovative Design.",
                    "Unparalleled Customer Service.",
                    "Highest Standards in Manufacturing."
                 ];
    var paragraph = [ "We’ve devoted over fifty years to producing comfortable, durable, safe and stylish bath products of the highest quality and value.", 
                      "Customers choose Seachrome with confidence, because they know that they can rely on us to provide dedicated customer service – starting with a live person answering every call.", 
                      "From initial design through final production, we are proud to manufacture Seachrome products in the USA." 
                    ];
    var uri = [ siteUrl + "signature", 
                siteUrl + "why-seachrome",
                siteUrl + "about" 
              ];
    var scenes = [  "home_scenes1.png",
                    "home_scenes2.png",
                    "home_scenes3.png" 
                 ];
    
    // Function to fade out, replace content and fade in for homepage slideshow
    function slideShow(index) {
        $( ".slide-content" ).fadeTo(250, 0.25, function() {
        $( "#slide-header" ).text( header[index] );
        $( "#slide-paragraph" ).text( paragraph[index] );
        $( "#slide-button" ).attr( "href", uri[index] );
        $( "#slide-image" ).attr( "src", uploadsUrl + scenes[index] );
        $( ".slide-content" ).fadeTo(250, 1);
      });
    }
    
    // Timer function for slideshow
    var index = 0;
    setInterval(function() {
      if (++index > 2) { index = 0; }
      slideShow(index);
    }, 4000); // 4 seconds
    
    // Responsive carousel for product images
    $('#product_slideshow').not('.slick-initialized').slick({
      arrows: true,
      dots: false,
      adaptiveHeight: true,
      slidesToShow: 5,
      slidesToScroll: 5,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          }
        },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          }
        }
      ]
    });
    
    // Product carousel show product clicked
    $( '.productButton' ).click(function() {
      var partName;
      var partDiv = $("#product" + $(this).attr("id"));
      $('.product').removeClass('product-show');
      $('.product').removeClass('product-hide');
      $('.product').addClass('product-hide');
      partDiv.removeClass('product-hide').addClass('product-show');
      $('.productButton').removeClass('full_opacity').addClass('half_opacity');
      $(this).removeClass('half_opacity').addClass('full_opacity');
      partName = partDiv.find('h2').first().text();
      $('#product_name').text(partName);
      var currentURI = new URI();
      var newURI = currentURI.setSearch( 'product', partName );
      window.history.pushState( '', '', newURI );
    });
    
    // Play videos on scroll using jquery.visible.js plugin
    $(window).scroll(function() {
        $('video').each(function() {
            if ($(this).visible(true)) {
                $(this)[0].play();
            } else {
                $(this)[0].pause();
            }
        })
    });
    
    // Zoom product image.
    $( '.zoomButton' ).click(function() {
      var zoomButton = $( this ).parent().parent().parent().find( 'img' );
      var imgZoom = new ImageZoom( zoomButton );
    });
    
    // Archive list show more/less
    $( '.show-more' ).click(function() {
      $( '.archive-small' ).hide();
      $( '.archive-large' ).show();
    });
    
    $( '.show-less' ).click(function() {
      $( '.archive-large' ).hide();
      $( '.archive-small' ).show();
    });
    
    // Product images download nav
    $( '#product-images-nav li' ).click(function() {
      $( this ).siblings().removeClass('selected');
      $( '.product-group' ).removeClass('selected');
      $( '#' + $( this ).attr('class') ).addClass('selected');
      $( this ).addClass('selected');
    });
    
    // Finishes swatch popup
    $( '.finishes img' ).click(function() {
      $( '.large-finish' ).hide();
      $( '#' + $( this ).attr('class') ).show();
    });
    
    $( '.large-finish .close' ).click(function() {
      $( '.large-finish' ).hide();
    });
    
    $( '.needsclick .frm_compact_text' ).click(function() {
      $( '.fallback input' ).trigger( "click" );
    });
    
    // Show search form under header
    $('.search-icon').on('click', function () {
      if ( $( '.search-dropdown' ).is(':visible') ) {
        $( '.search-dropdown' ).slideUp( "slow", function() {
          // Animation complete.
          $( '.search-icon' ).removeClass( 'shown' );
        });
      } else {
        $( '.search-icon' ).addClass( 'shown' );
        $( '.search-dropdown' ).slideDown( "slow", function() {
          // Animation complete.
        });
      }
    }).find('.search-dropdown').on('click', function (e) {
      // Don't retract .search-dropdown when clicked
      e.stopPropagation();
    });
    
    var t;
    var v;
    /* Get PDF downloads from pulldown menu when Download button is clicked */
    $('#button1').click(function(){
      t = $('#download_file1 option:selected').text();
      v = '/file_downloads/' + $('#download_file1 option:selected').val();
      if (t == 'Select Model') {
        window.alert("Select model at left to choose document to download");
        return;
      }
      window.open( v, '_blank' );
    }).change();
    $('#button2').click(function(){
      t = $('#download_file2 option:selected').text();
      v = '/file_downloads/' + $('#download_file2 option:selected').val();
      if (t == 'Select Model') {
        window.alert("Select model at left to choose document to download");
        return;
      }
      window.open( v, '_blank' );
    }).change();
    $('#button3').click(function(){
      t = $('#download_file3 option:selected').text();
      v = '/file_downloads/' + $('#download_file3 option:selected').val();
      if (t == 'Select Model') {
        window.alert("Select model at left to choose document to download");
        return;
      }
      window.open( v, '_blank' );
    }).change();
    $('#button4').click(function(){
      t = $('#download_file4 option:selected').text();
      v = '/file_downloads/' + $('#download_file4 option:selected').val();
      if (t == 'Select Model') {
        window.alert("Select model at left to choose document to download");
        return;
      }
      window.open( v, '_blank' );
    }).change();
    $('#button5').click(function(){
      t = $('#download_file5 option:selected').text();
      v = '/file_downloads/' + $('#download_file5 option:selected').val();
      if (t == 'Select Option') {
        window.alert("Select option at left to choose document to download");
        return;
      }
      window.open( v, '_blank' );
    }).change();
    $('#button6').click(function(){
      t = $('#download_file6 option:selected').text();
      v = '/file_downloads/' + $('#download_file6 option:selected').val();
      if (t == 'Select Option') {
        window.alert("Select option at left to choose document to download");
        return;
      }
      window.open( v, '_blank' );
    }).change();
    $('#button7').click(function(){
      t = $('#download_file7 option:selected').text();
      v = '/file_downloads/' + $('#download_file7 option:selected').val();
      if (t == 'Select Option') {
        window.alert("Select option at left to choose document to download");
        return;
      }
      window.open( v, '_blank' );
    }).change();
    $('#button8').click(function(){
      t = $('#download_file8 option:selected').text();
      v = '/file_downloads/' + $('#download_file8 option:selected').val();
      if (t == 'Select Option') {
        window.alert("Select option at left to choose document to download");
        return;
      }
      window.open( v, '_blank' );
    }).change();
    $('#button9').click(function(){
      t = $('#download_file9 option:selected').text();
      v = '/file_downloads/' + $('#download_file9 option:selected').val();
      if (t == 'Select Model') {
        window.alert("Select model at left to choose document to download");
        return;
      }
      window.open( v, '_blank' );
    }).change();
    
    $( '.risk .outline-button' ).click(function(e) {
      if( $('#lift-assist-full').length ) {
        assistPlayer.stopVideo();
      }
      proactivePlayer.stopVideo();
      $( '.video-cell' ).hide();
      $( '.full-video-cell' ).show();
      $( '.lift-assist-seat' ).show();
      $( '.full-lift-assist' ).hide();
      $( '.proactive' ).show();
      $( '.proactive-video' ).hide();
      compliancePlayer.playVideo();
      e.preventDefault();
    });
    
    $( '.lift-assist-seat .outline-button' ).click(function(e) {
      compliancePlayer.stopVideo();
      proactivePlayer.stopVideo();
      $( '.lift-assist-seat' ).hide();
      $( '.full-lift-assist' ).show();
      $( '.video-cell' ).show();
      $( '.full-video-cell' ).hide();
      $( '.proactive' ).show();
      $( '.proactive-video' ).hide();
      assistPlayer.playVideo();
      e.preventDefault();
    });
    
    $( '.proactive .outline-button' ).click(function(e) {
      compliancePlayer.stopVideo();
      if( $('#lift-assist-full').length ) {
        assistPlayer.stopVideo();
      }
      $( '.proactive' ).hide();
      $( '.proactive-video' ).show();
      $( '.lift-assist-seat' ).show();
      $( '.full-lift-assist' ).hide();
      $( '.video-cell' ).show();
      $( '.full-video-cell' ).hide();
      proactivePlayer.playVideo();
      e.preventDefault();
    });
    
  });
  
}) (jQuery);

function onYouTubeIframeAPIReady() {
  compliancePlayer = new YT.Player('video-full', {
      events: {
        'onReady': onPlayerReady,
        'onStateChange': onPlayerStateChange
      }
  });
  assistPlayer = new YT.Player('lift-assist-full', {
      events: {
        'onReady': onPlayerReady,
        'onStateChange': onPlayerStateChange
      }
  });
  proactivePlayer = new YT.Player('proactive-youtube', {
    events: {
      'onReady': onPlayerReady,
      'onStateChange': onPlayerStateChange
    }
  });
}
function onPlayerReady(event) {
  // do nothing
}
function playerChange(playerStatus) {
  if (playerStatus == -1) {
    // unstarted
  } else if (playerStatus == 0) {
    // ended
    jQuery( '.lift-assist-seat' ).show();
    jQuery( '.full-lift-assist' ).hide();
    jQuery( '.video-cell' ).show();
    jQuery( '.full-video-cell' ).hide();
    jQuery( '.proactive' ).show();
    jQuery( '.proactive-video' ).hide();
  } else if (playerStatus == 1) {
    // playing
  } else if (playerStatus == 2) {
    // paused
  } else if (playerStatus == 3) {
    // buffering
  } else if (playerStatus == 5) {
    // video cued
  }
}
function onPlayerStateChange(event) {
  playerChange(event.data);
}